
import { request } from "@fanfanlo";
import { tms } from "../tms";

// --- 类型定义 ---

/**
 * @description 提交举报的请求参数
 */
export interface ISubmitReportParams {
    reported_mobile: string; // 改为手机号
    report_type: string;
    target_ref?: string;
    reason: string;
    content_snapshot?: any;
}

/**
 * @description 提交举报的响应结果
 */
export interface ISubmitReportResult {
    is_ok: boolean;
    msg: string;
    report_id?: string;
}

/**
 * @description 提交一个新的举报
 * @param {ISubmitReportParams} params - 举报的详细信息
 * @returns {Promise<ISubmitReportResult>}
 */
export async function submitReport(params: ISubmitReportParams)  {
    return await request<ISubmitReportResult>(
        tms.TReport,
        tms.MReportSubmit,
        params
    );
}
